<template>
<div>
  <div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <SideBar />
    <!-- /#sidebar-wrapper -->
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-muted mb-0 hover-cursor">&nbsp;Insurance /&nbsp;</p>
            <p class="text-primary mb-0 hover-cursor">Polis List</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
                <div class="container">
                    <!-- Filter Part -->
                    <div>
                        <div class="row">
                            <div class="container" style="display : flex;">
                            <div class="col" style="padding-left : 0px">
                                Order ID
                                <input type="text" class="form-control" name="search_order_id" v-model="searchOrderCode" placeholder="Order Id">
                            </div>
                            <div class="col" style="padding-left : 0px">
                                Lessee Name
                                <input type="text" class="form-control" name="search_lessee_name" v-model="searchLesseeName" placeholder="Lessee Name">
                            </div>
                            <div class="col" style="padding-left : 0px">
                                Product Code
                                <input type="text" class="form-control" name="search_product_code" v-model="searchProductCode" placeholder="Product Code">
                            </div>
                                <div class="col" style="padding-left : 0px">
                                    Declared Date (from)
                                    <input type="date" class="form-control" name="search_start_rent_from" v-model="searchDeclaredDateFrom">
                                </div>
                                <div class="col" style="padding-left : 0px">
                                    Declared Date (to)
                                    <input type="date" class="form-control" name="search_start_rent_from" v-model="searchDeclaredDateTo">
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="container-fluid" style="display : flex;">
                            <div class="col" style="padding-left : 0px">
                                Start Rent (from)
                                <!-- <input type="text" class="form-control" name="search_invoice_id" v-model="searchInvoiceNo" placeholder="Invoice Number"> -->
                                <input type="date" class="form-control" name="search_start_rent_from" v-model="searchStartRentFrom">
                            </div>
                            <div class="col" style="padding-left : 0px">
                                Start Rent (to)
                                <input type="date" class="form-control" name="search_start_rent_to" v-model="searchStartRentTo">
                            </div>
                            <div class="col" style="padding-left : 0px">
                                End Rent (from)
                                <input type="date" class="form-control" name="search_end_rent_to" v-model="searchEndRentFrom">
                            </div>
                            <div class="col" style="padding-left : 0px">
                                End Rent (to)
                                <input type="date" class="form-control" name="search_end_rent_to" v-model="searchEndRentTo">
                            </div>
                            <div style="padding-left : 0px; margin-top : 25px;" class="col">
                                <button class="btn btn-primary" style="width: 48%;" @click="searchData">Cari</button>
                                <button class="btn btn-outline-primary" style="width: 48%;" @click="resetFilter">Reset</button>
                            </div>
                            </div>
                        </div>
                    </div>
                    <!-- ENF OF FILTER PART -->
                    <div class ="mt-4 mb-2" style="display : flex; justify-content : space-between">
                        <div id="details-title">Details</div>
                        <button class="btn btn-sm btn-outline-secondary btn-export-polis" @click="exportPolisList">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M9 13L15 13" stroke="#3098F7" stroke-width="2" stroke-linecap="round"/>
                                <path d="M9 9L13 9" stroke="#3098F7" stroke-width="2" stroke-linecap="round"/>
                                <path d="M9 17L13 17" stroke="#3098F7" stroke-width="2" stroke-linecap="round"/>
                                <path d="M19 13V17C19 18.8856 19 19.8284 18.4142 20.4142C17.8284 21 16.8856 21 15 21H9C7.11438 21 6.17157 21 5.58579 20.4142C5 19.8284 5 18.8856 5 17V7C5 5.11438 5 4.17157 5.58579 3.58579C6.17157 3 7.11438 3 9 3H11" stroke="#3098F7" stroke-width="2"/>
                                <path d="M18.75 1.5L19.3864 0.863604L18.75 0.227208L18.1136 0.863604L18.75 1.5ZM17.85 8.25C17.85 8.74706 18.2529 9.15 18.75 9.15C19.2471 9.15 19.65 8.74706 19.65 8.25L17.85 8.25ZM23.1364 4.6136L19.3864 0.863604L18.1136 2.1364L21.8636 5.8864L23.1364 4.6136ZM18.1136 0.863604L14.3636 4.6136L15.6364 5.8864L19.3864 2.1364L18.1136 0.863604ZM17.85 1.5L17.85 8.25L19.65 8.25L19.65 1.5L17.85 1.5Z" fill="#3098F7"/>
                            </svg>
                            Export
                        </button>
                    </div>
                
                    <table class="table table-sm table-bordered table-striped table-responsive-sm mt-2">
                        <thead class="">
                        <tr>
                            <th style="max-width : 200px;">Order Details</th>
                            <th style="max-width : 200px;">Product Details</th>
                            <th>Product Code</th>
                            <th>Start Rent</th>
                            <th>End Rent</th>
                            <th>Prorate</th>
                            <th>Declare Date</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="loadingTable == true">
                            <td colspan="9" class="text-center"><img src="~@/assets/images/load-button.gif" /></td>
                        </tr>
                        <tr v-else-if="loadingTable == false && totalData == 0">
                            <td colspan="9" class="text-center">Data not available</td>
                        </tr>
                        <tr v-for="data in dataInsurance" :key="data.orderDetailsId" v-else>
                            <td style="text-align: left; max-width :200px;"> 
                            {{data.orderCode}} <br />
                            <b>{{data.companyName}}</b>
                            </td>
                            <td style="text-align: left; max-width :200px; "> 
                            {{`${data.productTitle}`}}<br/>
                            {{data.specificationsView}}
                            </td>
                            <td>{{data.productCode}}</td>
                            <td>{{data.startRent}}</td>
                            <td>{{data.endRent}}</td>
                            <td>{{data.prorate}}</td>
                            <td class="text-center">
                            {{formatDeclareDate(data.declaredAt)}}
                            </td>
                            <td class="text-center">
                                <button class="btn btn-sm btn-outline-primary btn-polis" @click="viewPolisList(data.docs)" v-if="data.docs">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                                        <path d="M1.87524 0.060421C0.99388 0.288575 0.284412 1.00117 0.0625082 1.88566C0 2.12944 0 2.24508 0 7.99896C0 13.7528 0 13.8685 0.0625082 14.1123C0.0968876 14.2466 0.19065 14.4936 0.268785 14.6561C0.396927 14.9124 0.459435 14.9936 0.731345 15.2655C1.00013 15.5343 1.09077 15.6031 1.34393 15.7281C1.88775 16 1.89712 16 3.79112 16H5.44759L5.58198 15.9219C5.77888 15.8062 5.87577 15.625 5.87577 15.3749C5.87577 15.1249 5.77888 14.9436 5.58198 14.828L5.44759 14.7498H4.01302C3.21917 14.7498 2.48157 14.7342 2.35968 14.7186C2.06277 14.6748 1.84399 14.5654 1.63771 14.3623C1.43456 14.156 1.32517 13.9372 1.28142 13.6403C1.24079 13.3403 1.24079 2.65763 1.28142 2.3576C1.32517 2.06068 1.43456 1.8419 1.63771 1.63563C1.84399 1.43247 2.06277 1.32308 2.35968 1.27933C2.6566 1.2387 10.0326 1.2387 10.3295 1.27933C10.7514 1.34184 11.1139 1.60437 11.3015 1.98255L11.3921 2.17007L11.4077 5.40487L11.4234 8.63966L11.4952 8.77406C11.6015 8.97408 11.8047 9.09285 12.0453 9.09285C12.286 9.09285 12.4641 9.00846 12.5829 8.83657L12.6735 8.70842L12.6829 5.4705C12.6892 3.22021 12.6798 2.17007 12.6579 2.03255C12.4985 1.10118 11.7453 0.304202 10.8014 0.060421C10.5576 -0.00208664 10.4701 -0.00208664 6.33208 0.0010376C2.2628 0.0010376 2.10027 0.00416279 1.87524 0.060421Z" fill="#1C68D9"/>
                                        <path d="M2.82851 3.80297C2.60348 3.92173 2.49097 4.11238 2.49097 4.37492C2.49097 4.60932 2.58473 4.78747 2.77225 4.90936L2.91915 5H6.32584C9.68878 5 9.73254 5 9.8638 4.93749C9.93881 4.89999 10.0326 4.8156 10.0826 4.74372C10.1638 4.62808 10.1732 4.58745 10.1732 4.37492C10.1732 4.16864 10.1607 4.11863 10.0888 4.00925C10.0388 3.93424 9.95131 3.8561 9.87005 3.81547L9.73254 3.74984H6.32584C3.28169 3.75296 2.9129 3.75609 2.82851 3.80297Z" fill="#1C68D9"/>
                                        <path d="M2.82851 6.30297C2.60348 6.42173 2.49097 6.61238 2.49097 6.87492C2.49097 7.10932 2.58473 7.28747 2.77225 7.40936L2.91915 7.5H6.32584C9.68878 7.5 9.73254 7.5 9.8638 7.43749C9.93881 7.39999 10.0326 7.3156 10.0826 7.24372C10.1638 7.12808 10.1732 7.08745 10.1732 6.87492C10.1732 6.66864 10.1607 6.61863 10.0888 6.50925C10.0388 6.43424 9.95131 6.3561 9.87005 6.31547L9.73254 6.24984H6.32584C3.28169 6.25296 2.9129 6.25609 2.82851 6.30297Z" fill="#1C68D9"/>
                                        <path d="M2.82851 8.80297C2.60348 8.92173 2.49097 9.11238 2.49097 9.37492C2.49097 9.60932 2.58473 9.78747 2.77225 9.90936L2.91915 10H4.76314H6.604L6.7384 9.92186C6.9353 9.80622 7.03218 9.62495 7.03218 9.37492C7.03218 9.12489 6.9353 8.94361 6.7384 8.82797L6.604 8.74984H4.76314C3.14418 8.75296 2.90977 8.75921 2.82851 8.80297Z" fill="#1C68D9"/>
                                        <path d="M9.28557 10.0016C8.58861 10.1516 7.90102 10.5079 7.22905 11.0736C6.74462 11.4768 6.06328 12.2175 5.81637 12.6082C5.73198 12.7394 5.71948 12.7894 5.71948 12.9676C5.71948 13.1457 5.73198 13.1957 5.81637 13.327C6.0789 13.7396 6.81963 14.5334 7.31657 14.9335C7.88852 15.396 8.50735 15.7273 9.11993 15.8961C9.40121 15.9742 9.46685 15.9805 10.0325 15.9805C10.5951 15.9805 10.6639 15.9742 10.942 15.8961C11.5109 15.7398 12.0484 15.4679 12.5891 15.0647C13.1079 14.674 13.9143 13.8333 14.2237 13.3614C14.3331 13.1926 14.3456 13.1582 14.3456 12.9676C14.3456 12.7769 14.3331 12.7425 14.2237 12.5738C13.9143 12.1018 13.1079 11.2611 12.5891 10.8704C12.0422 10.461 11.5109 10.1922 10.9452 10.0391C10.6858 9.97031 10.5639 9.95781 10.1107 9.94843C9.66687 9.93906 9.53248 9.94843 9.28557 10.0016ZM10.742 11.3205C11.0796 11.4393 11.4859 11.6612 11.7984 11.8956C12.0734 12.105 12.7298 12.7332 12.8329 12.8894C12.8798 12.9613 12.8798 12.9738 12.8329 13.0457C12.7329 13.1989 12.0766 13.8302 11.7984 14.0396C11.4546 14.299 10.917 14.5709 10.5826 14.6553C10.2513 14.7397 9.81377 14.7397 9.48247 14.6553C9.14805 14.5709 8.61048 14.299 8.26669 14.0396C7.98853 13.8302 7.33219 13.1989 7.23218 13.0457C7.1853 12.9738 7.1853 12.9613 7.23218 12.8894C7.33219 12.7363 7.98853 12.105 8.26669 11.8956C8.60111 11.6424 9.1418 11.3642 9.46997 11.2799C9.81377 11.1892 10.4263 11.208 10.742 11.3205Z" fill="#1C68D9"/>
                                        <path d="M9.61391 11.856C9.28574 11.9935 9.06071 12.2248 8.93882 12.5529C8.88256 12.6998 8.87319 12.7842 8.88256 13.0155C8.89194 13.2593 8.90757 13.328 8.99195 13.503C9.11384 13.7499 9.31074 13.9406 9.55765 14.0562C9.71392 14.1312 9.7733 14.1406 10.064 14.1406C10.3546 14.1406 10.414 14.1312 10.5703 14.0562C10.8172 13.9406 11.0141 13.7499 11.136 13.503C11.2297 13.3124 11.236 13.278 11.236 12.9686C11.236 12.6592 11.2297 12.6248 11.136 12.4342C11.0141 12.1872 10.8172 11.9966 10.5703 11.881C10.4234 11.8122 10.339 11.7966 10.0952 11.7872C9.83894 11.7809 9.7733 11.7903 9.61391 11.856Z" fill="#1C68D9"/>
                                    </svg>
                                    Polis
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <div id="wrapperr">
                        <div id="c1" style="display: inline-flex;">
                        <div style="margin-right: 10px;">
                            <select class="form-control form-control-sm" v-model="itemPerPage" @change="searchData()">
                            <option value="10">10</option>
                            <option value="40">40</option>
                            <option value="80">80</option>
                            </select>
                        </div>
                        <div class="alignLeft total-data">
                            Total Data {{ totalData }}
                        </div>
                        </div>
                        <div id="c2">
                        <div class="pagination p8 alignRight">
                            <ul>
                            <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1">
                                <li>
                                {{'<'}}</li> </a> <a class="page">
                                <li>{{ currentPage }} of {{ totalPage }} page</li>
                            </a>
                            <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage">
                                <li>></li>
                            </a>
                            </ul>
                        </div>
                        </div>
                    </div>
                
                </div>
            </div>
        </div>
      </div>
    </div>
    <!-- /#page-content-wrapper -->
    <!-- Modal preview polis -->
    <div class="modal fade" id="modalViewInsurancePolis" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">List Polis Docs</h4>
            </div>
            <button type="button" class="close" @click="searchData()" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <table class="table table-sm table-bordered table-striped table-responsive-sm mt-2">
              <thead class="">
                <tr>
                  <th>From</th>
                  <th>To</th>
                  <th>Prorate</th>
                  <th>Sum Insured</th>
                  <th>Premium</th>
                  <th>Issued By</th>
                  <th>Issued Time</th>
                  <th>Trx Polis</th>
                  <th>Link Polis</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loadingTable == false && polisDocList.length == 0">
                  <td colspan="9" class="text-center">Data not available</td>
                </tr>
                <tr v-else v-for="(data, index)  in polisDocList" :key="index">
                  <td>{{data.insuranceFrom}}</td>
                  <td>{{data.insuranceTo}}</td>
                  <td>{{data.insuranceProrate}}</td>
                  <td>{{data.insuranceSum}}</td>
                  <td>{{data.insurancePremium}}</td>
                  <td>{{data.insuranceName}}</td>
                  <td>{{data.insuranceTime}}</td>
                  <td>{{data.trxId}}</td>
                  <td class="text-center">
                    <a v-bind:href="data.insuranceAsaniUrl+'?token='+token" target="_blank">ASANI</a>
                    <span class="vl"></span>
                    <a v-bind:href="data.insuranceVendorUrl" target="_blank">PREMIRO</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- End Of Modal preview polis -->

  </div>
</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Swal from 'sweetalert2';
import SideBar from "../SideBar";
import { Money } from "v-money";
export default {
  name: "insurancePolisListPage",
  components: {
    SideBar,
    Multiselect,
    Money,
  },
  data() {
    return {
      loadingTable: false,
      loadingCart : false,
      loadingCreateBatch : false,
      openCart : false,
      cartCount : 0,
      batchInsuranceOptions : [
        {
          batchName : '1111'
        },
        {
          batchName : '2222'
        }
      ],
      insuranceStatusOptions : [
        {
          statusName : 'Pending'
        },
        {
          statusName : 'No Issue'
        }
      ],
      searchOrderCode : '',
      searchLesseeName :'',
      searchProductCode:'',
      searchStartRentFrom:'',
      searchStartRentTo:'',
      searchEndRentFrom:'',
      searchEndRentTo:'',
      searchDeclaredDateFrom : '',
      searchDeclaredDateTo : '',
      source: "",
      admin: "",
      permission: [],
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      itemPerPage: 10,
      dataInsurance: [],
      token: localStorage.getItem("jwt"),
      password: "",
      disableSave: false,
      polisDocList : [],
    };
  },
  methods: {
    viewPolisList(docs) {
      docs.forEach(data => {
        const {
          insuranceFrom,
          insuranceTo,
          insuranceProrate,
          insuranceSum,
          insuranceName,
          insuranceTime,
          premiroId: trxId,
          insuranceAsaniUrl,
          insurancePremiroUrl: insuranceVendorUrl} = data

        this.polisDocList.push({
          insuranceFrom,
          insuranceTo,
          insuranceProrate,
          insuranceSum,
          insuranceName,
          insuranceTime,
          trxId,
          insuranceAsaniUrl,
          insuranceVendorUrl
        })
      })
        this.openModal('ViewInsurancePolis')
    },
    formatDeclareDate(data) {
      if(!data) {
        return '';
      }
      const monthString = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October','November', 'December']
      let dataFraction = data.split('-')
      let result = `${dataFraction[2].split(' ')[0]} ${monthString[dataFraction[1][0] == 0 ? dataFraction[1][1]-1 :dataFraction[1]-1]} ${dataFraction[0]}`
      return result
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if(['22','22.1', '22.2', '22.3'].includes(this.permission[i])) {
          this.viewNewInsurance = true
        }
        if(this.permission[i] == '22.1') {
          this.viewNewInsuranceVendor = true
        }
        if(this.permission[i] == '22.2') {
          this.viewNewInsurancePendingDeclare = true
        }
        if(this.permission[i] == '22.3') {
          this.viewNewInsuranceBatch = true
        }

        if (this.viewNewInsurancePendingDeclare == false) {
          this.$router.push('/')
        }
      }
    },
    sendLog(w, x) {
      // var today = new Date();
      // var month = today.getMonth()+1
      // if (month < 10) {
      //     month = '0'+month
      // }
      // var dateDay = today.getDate()
      // if (dateDay < 10) {
      //     dateDay = '0'+dateDay
      // }
      // var hours = today.getHours()
      // if (hours < 10) {
      //     hours = '0'+hours
      // }
      // var minutes = today.getMinutes()
      // if (minutes < 10) {
      //     minutes = '0'+minutes
      // }
      // var second = today.getSeconds()
      // if (second < 10) {
      //     second = '0'+second
      // }
      // var date = today.getFullYear()+'-'+month+'-'+dateDay;
      // var time = hours + ":" + minutes + ":" + second;
      // var dateTime = date+' '+time;
      // var admin = this.admin
      // var command = 'add-logs'
      // // var productName = this.productNameChoose
      // this.$http.post(process.env.LOG_URL+"/company/"+x,{
      //     codeLogs: w,
      //     params: [],
      // },{
      //     headers: {'Asani-Token':localStorage.getItem('jwt')}
      // })
      // .then(response => {
      // })
      // .catch(error => {
      //     console.log(error)
      // })
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    resetFilter() {
      this.searchLesseeName= '';
      this.searchProductCode= '';
      this.searchOrderCode = '';
      this.searchStartRentFrom= '';
      this.searchStartRentTo= '';
      this.searchEndRentFrom= '';
      this.searchEndRentTo= '';
      this.searchDeclaredDateFrom= '';
      this.searchDeclaredDateTo= '';

      this.$router.push({
        path: "/insurance/polis",
        query: {
          page: 1,
          itemPerPage: 10,
          orderCode: this.searchOrderCode,
          lesseeName: this.searchLesseeName,
          productCode: this.searchProductCode,
          startRentFrom : this.searchStartRentFrom,
          startRentTo : this.searchStartRentTo,
          endRentFrom : this.searchEndRentFrom,
          endRentTo : this.searchEndRentTo,
          declaredDateFrom : this.searchDeclaredDateFrom,
          declaredDateTo : this.searchDeclaredDateTo,
          
        },
      });
    },
    searchData() {
      // console.log(this.searchInsuranceStatus)
      this.$router.push({
        path: "/insurance/polis",
        query: {
          page: 1,
          itemPerPage: this.itemPerPage,
          orderCode: this.searchOrderCode,
          lesseeName: this.searchLesseeName,
          productCode: this.searchProductCode,
          startRentFrom : this.searchStartRentFrom,
          startRentTo : this.searchStartRentTo,
          endRentFrom : this.searchEndRentFrom,
          endRentTo : this.searchEndRentTo,
          declaredDateFrom : this.searchDeclaredDateFrom,
          declaredDateTo : this.searchDeclaredDateTo,
        },
      });
    },
    toDataPage(pagePost) {
      this.$router.push({
        path: "/insurance/polis",
        query: {
          page: pagePost,
          itemPerPage: this.itemPerPage,
          orderCode: this.searchOrderCode,
          lesseeName: this.searchLesseeName,
          productCode: this.searchProductCode,
          startRentFrom : this.searchStartRentFrom,
          startRentTo : this.searchStartRentTo,
          endRentFrom : this.searchEndRentFrom,
          endRentTo : this.searchEndRentTo,
          declaredDateFrom : this.searchDeclaredDateFrom,
          declaredDateTo : this.searchDeclaredDateTo,
        },
      });
    },
    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    openModal(modalName) {
      $("#modal" + modalName).modal("show");
    },
    getData() {
      this.loadingTable = true;
      this.searchLesseeName = this.$route.query.lesseeName;
      this.searchOrderCode = this.$route.query.orderCode;
      this.searchStartRentFrom = this.$route.query.startRentFrom;
      this.searchStartRentTo = this.$route.query.startRentTo;
      this.searchEndRentFrom = this.$route.query.endRentFrom;
      this.searchEndRentTo = this.$route.query.endRentTo;
      this.searchDeclaredDateFrom = this.$route.query.declaredDateFrom;
      this.searchDeclaredDateTo = this.$route.query.declaredDateTo;
      this.searchProductName = this.$route.query.productName;
      this.searchProductCode = this.$route.query.productCode;
      this.searchProductName = this.$route.query.productName;
      this.currentPage = parseInt(this.$route.query.page);
      this.itemPerPage = parseInt(this.$route.query.itemPerPage);

      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      this.$http
      .post(
          process.env.NEW_SEARCH_INSURANCE, {
            download: false,
            page: this.currentPage,
            itemPerPage: this.itemPerPage,
            orderCode: this.searchOrderCode,
            lesseeName: this.searchLesseeName,
            productName: this.searchProductName,
            productCode: this.searchProductCode,
            startRentFrom : this.searchStartRentFrom,
            startRentTo : this.searchStartRentTo,
            endRentFrom : this.searchEndRentFrom,
            endRentTo : this.searchEndRentTo,
            declareFrom : this.searchDeclaredDateFrom,
            declareTo: this.searchDeclaredDateTo,
            insuranceStatus: [],
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
            timeout: 300 * 1000,
          }
        )
      .then((response) => {
        if(response.status == 200 || response.data.status == 200) {
          this.dataInsurance = response.data.content.data ? response.data.content.data : [];
          this.totalPage = response.data.content.totalPage;
          this.totalData = response.data.content.totalData;
          this.currentPage = response.data.content.currentPage;
        } else {
          swalWithBootstrapButtons.fire({
            icon: "error",
            title: "Failed",
            text: response.data.message,
          }).then((result) => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
            
            if(result.isConfirmed) {
            } 
          });
        }
          this.loadingTable = false;
        })
      .catch(error => {
        swalWithBootstrapButtons.fire({
          icon: "error",
          title: "Failed",
          text: error,
        }).then((result) => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }

          if(result.isConfirmed) {
          } 
        });
      });
    },
    exportPolisList() {
      this.$http
      .post(
          process.env.NEW_SEARCH_INSURANCE, {
            download: true,
            page: this.currentPage,
            itemPerPage: this.itemPerPage,
            orderCode: this.searchOrderCode,
            lesseeName: this.searchLesseeName,
            productName: this.searchProductName,
            productCode: this.searchProductCode,
            startRentFrom : this.searchStartRentFrom,
            startRentTo : this.searchStartRentTo,
            endRentFrom : this.searchEndRentFrom,
            endRentTo : this.searchEndRentTo,
            declareFrom : this.searchDeclaredDateFrom,
            declareTo: this.searchDeclaredDateTo,
            insuranceStatus: [],
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
            responseType: 'arraybuffer', 
            timeout: 300 * 1000,
          },
        )
      .then((response) => {
        if(response.status == 200 || response.data.status == 200) {
          const a = document.createElement('a')
          const date = new Date
          const reader = new FileReader();
          const blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
          reader.readAsDataURL(blob);
          reader.onloadend = function (e) {
            a.href = reader.result
            a.download = `Insurance_Data(${date.getDate()}-${date.getMonth()+1}-${date.getFullYear()}).xlsx`
            a.click()
          }
        } else {
          swalWithBootstrapButtons.fire({
            icon: "error",
            title: "Failed",
            text: response.data.message,
          }).then((result) => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }

            if(result.isConfirmed) {
            } 
          });
        }
         
          this.loadingTable = false;
        })
      .catch(error => {
        swalWithBootstrapButtons.fire({
          icon: "error",
          title: "Failed",
          text: error,
        }).then((result) => {
          if(result.isConfirmed) {
          } 
        });
      });
    },
    dateFormat($date) {
      const d = new Date($date)
      if (d.getDate().toString().length == 1) {
        var date = '0' + d.getDate().toString()
      } else {
        date = d.getDate()
      }
      if ((d.getMonth() + 1).toString().length == 1) {
        var month = '0' + (d.getMonth() + 1).toString()
      } else(
        month = (d.getMonth() + 1)
      )
      return date + '-' + month + '-' + d.getFullYear()
    },

  },
  created() {
    const allPermission = JSON.parse(localStorage.getItem('roles'))
    this.cancelInsurancePermission = allPermission && allPermission.indexOf('15.2') >= 0
    this.getData();
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.cekLogin();
    this.cekPermission();
  },
  watch: {
  },
  // computed: {
  // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.vl {
    border-left: 1.5px solid;
    border-color: rgba(46, 54, 70, 1);
    height: 110px;
    margin-right: 3px;
}
#details-title {
    font-size: 18px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.001em;
    text-align: left;
    color: #212541;
}

td {
  text-align: center;
  font-size: 0.9em;
}
th {
  text-align: center;
  vertical-align: middle;
}
.btn-view-cart .badge {
  margin-top : 2px;
  position: absolute;
  top: -10px;
  padding: 5px 7px;
  border-radius: 50%;
  background: rgba(247, 143, 48, 1);
  color: white;
  font-weight: 700;
}
.btn-view-cart:hover {
  background-color: rgba(214, 234, 253, 1);
}
.btn-export-polis {
    border-radius: 8px;
    border-color: rgba(209, 217, 226, 1);
    color: rgba(46, 54, 70, 1);
}

.btn-export-polis:hover {
    background-color: rgba(209, 217, 226, 1);
    color: rgba(46, 54, 70, 1);
}
.item-badge {
  display: inline-block;
  padding: 0.25em 0.8em;
  font-size: 13px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 1rem;
  transition: color 0.15s;
  margin-right: 2px;
  color: rgba(247, 143, 48, 1);
}
.btn-add-cart{
  border-radius: 0.6rem;
}
.btn-add-cart:hover {
  background-color: rgba(214, 234, 253, 1);
}
.btn-polis{
  border-radius: 0.6rem;
}

.btn-polis:hover {
    background-color: rgba(214, 234, 253, 1);
    color: rgba(28, 104, 217, 1)
}

.total-data {
  margin-top: 7px;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.one-line {
  display: flex;
  margin: 5px 0px;
}

.border-red {
  border-color: red;
}

.one-line .ol-label.storage {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-roles {
  width: 130px;
  margin: 2px 0px;
}

.one-line .ol-label-price {
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2 {
  width: 15px;
  margin: 2px 0px;
}

.stPrice-sch {
  width: 186px;
  margin: 7px 0px;
}

.delivery-titik2 {
  margin: 7px 0px;
  padding-right: 7px;
}

.input-group-addon {
  padding: 7px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  margin: 0px 0px 0px 0px;
  height: fit-content;
}

.label-addon-rp {
  margin: 5px 0px;
}

.modal-lg,
.modal-xl {
  max-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Insurance/PolisListPage.vue